var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheckboxChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.011,
    height: 16,
    viewBox: "0 0 16.011 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51983",
    "data-name": "Group 51983",
    transform: "translate(-225.25 -558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43049",
    "data-name": "Group 43049",
    transform: "translate(225.25 558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43047",
    "data-name": "Group 43047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6536",
    "data-name": "Rectangle 6536",
    fill: "#fff",
    stroke: "#85888a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 1.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43048",
    "data-name": "Group 43048",
    transform: "translate(225.25 558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43047-2",
    "data-name": "Group 43047"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6536-2",
    "data-name": "Rectangle 6536",
    width: 16,
    height: 16,
    rx: 2,
    transform: "translate(0.011)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53179",
    "data-name": "Path 53179",
    d: "M373.387,6705.2l2.379,2.778,6.343-6.026",
    transform: "translate(-369.876 -6697.452)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxChecked);
export default __webpack_public_path__ + "static/media/icon-checkbox-checked.32e68be8.svg";
export { ForwardRef as ReactComponent };